import { AxiosResponse } from 'axios';
import { useEffect } from 'react';

import Resolver from 'src/common/Resolver';
import { UploadedFile } from 'src/interfaces/FileManager';
import { EView } from 'src/interfaces/View';
import useFileManagerStore from 'src/stores/fileManagerStore';
import FileManager from './FileManager';

interface FileManagerResolverProps {
  mode?: 'manage' | 'select';
  endpoint?: 'all' | 'image' | 'document' | 'trackMap';
  onSelect?: (file: UploadedFile) => void;
  multiple?: boolean;
  selectedFileIds?: string[];
  showTitle?: boolean;
  hideToolbar?: boolean;
  allowUpload?: boolean;
  view?: EView;
  onSetView?: (view: EView) => void;
}

const FileManagerResolver = ({ endpoint: initialEndpoint = 'all', ...rest }: FileManagerResolverProps) => {
  const { fetchFiles: doFetchFiles, setEndpointFilter } = useFileManagerStore(
    fileManagerState => fileManagerState,
  );

  // Set initial endpoint filter from props before fetching
  useEffect(() => {
    setEndpointFilter(initialEndpoint);
  }, [initialEndpoint, setEndpointFilter]);

  const loadDependencies = () => {
    // The fetchFiles action returns Promise<void>, which is compatible.
    const deps: Array<Promise<void | AxiosResponse<unknown>>> = [doFetchFiles()];
    return Promise.all(deps);
  };

  return <Resolver resolve={loadDependencies} successComponent={FileManager} successProps={{ endpoint: initialEndpoint, ...rest }} />;
};

export default FileManagerResolver;